import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export const Avatar = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', className)} {...props} data-id="element-642" />);
Avatar.displayName = 'Avatar';
export const AvatarImage = forwardRef<HTMLImageElement, React.ImgHTMLAttributes<HTMLImageElement>>(({
  className,
  ...props
}, ref) => <img ref={ref} className={cn('aspect-square h-full w-full', className)} {...props} data-id="element-643" />);
AvatarImage.displayName = 'AvatarImage';
export const AvatarFallback = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({
  className,
  ...props
}, ref) => <div ref={ref} className={cn('flex h-full w-full items-center justify-center rounded-full bg-muted', className)} {...props} data-id="element-644" />);
AvatarFallback.displayName = 'AvatarFallback';